import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from 'react-router-dom';

import { useLocation, Link } from "react-router-dom";
import PropTypes from "prop-types";

import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import Icon from "@mui/material/Icon";
import { FaCreditCard } from 'react-icons/fa';

import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import { MdOutlineSms, MdPerson } from "react-icons/md";

import Breadcrumbs from "examples/Breadcrumbs";
import NotificationItem from "examples/Items/NotificationItem";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useAuth } from 'utlis/authContext';
import Select from 'react-select';

import {
  navbar,
  navbarContainer,
  navbarRow,
  navbarIconButton,
  navbarContactIconButton,
  navbarMobileMenu,
} from "examples/Navbars/DashboardNavbar/styles";

import {
  useSoftUIController,
  setTransparentNavbar,
  setMiniSidenav,
  setOpenConfigurator,
} from "context";

import team4 from "assets/images/team-4.jpg";
import logoSpotify from "assets/images/small-logos/logo-spotify.svg";

import { getApiHeader } from "../../../utlis/commonfunctions";
import { Home } from "@mui/icons-material";
import AddPaymentMethod from "layouts/Features/AddPaymentMethod";
import CreditCard from "assets/images/credit-card-dummy.png";
import esim from "assets/images/rechargefriend.png";
import Wallet from "assets/images/wallet.svg";

const API_URL = process.env.REACT_APP_API_URL;
const API_TOKEN = process.env.REACT_APP_API_TOKEN;

function DashboardNavbar({ absolute, light, isMini }) {
  const navigate = useNavigate();
  const [navbarType, setNavbarType] = useState("static");
  const [controller, dispatch] = useSoftUIController();
  const { miniSidenav, transparentNavbar, fixedNavbar, openConfigurator } = controller;
  const [openMenu, setOpenMenu] = useState(false);
  const [amountList, setAmountList] = useState([]);
  const [selectedAmount, setSelectedAmount] = useState("");

  const name = sessionStorage.getItem('shop_code');

  const [wallet, setWallet] = useState(() => {
    const storedWallet = localStorage.getItem("walletAmount") || 0;
    return storedWallet ? `$${storedWallet}` : "0.00";
  });

  const userType = sessionStorage.getItem('userType');
  const MonthlyCredit = sessionStorage.getItem('monthlyCredit');
  const simOnlyUser = sessionStorage.getItem('simOnlyUser');

  const formatMenuName = (segments) => {
    return segments
      .map((segment) => segment.replace(/[-_]/g, " ").toUpperCase())
      .join(" / ");
  };

  const route = useLocation().pathname.split("/").slice(1);
  const menuName = formatMenuName(route);

  const handleSubmit = async (event) => {
    if (event) event.preventDefault();
    try {
      const response = await axios.get(`${API_URL}logout`, {
        headers: {
          "api-token": API_TOKEN,
          "Authorization": 'Bearer ' + sessionStorage.getItem('access_token'),
        },
      });
      sessionStorage.setItem('access_token', false);
      if (response.status === 200) {
        toast.success(response?.data?.message);
        sessionStorage.removeItem('accessToken');
        localStorage.removeItem('SelectedWalletAmount');
        sessionStorage.setItem('access_token', false);
        window.history.replaceState(null, null, '/login');
        window.history.pushState(null, null, '/login');
        setTimeout(() => {
          navigate('/login', { replace: true });
          toast.success(response?.data?.message);
        }, 1000);
        window.location.reload();
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
      console.error("An error occurred:", error);
    }
  };

  const { isAuthenticated } = useAuth();
  const token = sessionStorage.getItem('access_token');
  if (token === 'false' || token === null) {
    navigate('/login', { replace: true });
  }

  const handlePaymentMethod = () => {
    navigate('/add_payment_method', { replace: true });
  };

  const handleAmountChange = (selectedOption) => {
    setSelectedAmount(selectedOption);
  };

  const handleAddButton = () => {
    navigate('/wallet');
  };

  const handleNumber = async () => {
    try {
      const header = await getApiHeader();
      const response = await axios.get(`${API_URL}wallet/get-wallet-balance`, { headers: header });
      if (response.status === 200) {
        localStorage.setItem("walletAmount", response?.data?.wallet_balance);
        setWallet(response?.data?.wallet_balance);
      }
    } catch (error) {
      console.log("error in side nav", error);
    }
  };

  const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);
  const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !openConfigurator);

  const handleOpenMenu = (event) => {
    handleNumber();
    setOpenMenu(event.currentTarget);
    const walletAmount = localStorage.getItem("walletAmount") || 0;
    setWallet(walletAmount);
  };

  const handleCloseMenu = () => {
    setOpenMenu(false);
  };

  const renderMenu = () => (
    <Menu
      anchorEl={openMenu}
      anchorReference={null}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(openMenu)}
      onClose={handleCloseMenu}
      sx={{ mt: 2 }}
    >
      <NotificationItem
        image={<img src={team4} alt="person" />}
        title={["Retailer Id :", name]}
        onClick={handleCloseMenu}
      />

      {simOnlyUser != 1 && (
        <>
          <NotificationItem
            color="primary"
            image={<FaCreditCard color="white" size={30} style={{ padding: 3 }} />}
            title={["", "Add Payment Method"]}
            date=""
            onClick={handlePaymentMethod}
          />
          {MonthlyCredit == 0 && userType !== 'PAR' && (
            <NotificationItem
              color="primary"
              image={<img src={Wallet} style={{ padding: 5 }} alt="wallet" />}
              title={["", "Add Credit to Wallet"]}
              date={`$${wallet}`}
              onClick={handleAddButton}
            />
          )}
        </>
      )}

      <NotificationItem
        color="primary"
        image={
          <Icon fontSize="small" sx={{ color: ({ palette: { white } }) => white.main }}>
            logout
          </Icon>
        }
        title={["", "Logout"]}
        date=""
        onClick={handleSubmit}
      />
    </Menu>
  );

  return (
    <AppBar
      position={absolute ? "absolute" : navbarType}
      color="inherit"
      sx={(theme) => navbar(theme, { transparentNavbar, absolute, light })}
    >
      <ToastContainer hideProgressBar={false} position="top-right" autoClose={1000} />

      <Toolbar
        sx={(theme) => ({
          ...navbarContainer(theme),
          flexWrap: "wrap",
          gap: "8px",
          padding: { xs: "8px 12px", md: "8px 24px" },
          minHeight: { xs: "56px", md: "64px" },
        })}
      >
        {/* Breadcrumb row */}
        <SoftBox
          color="inherit"
          sx={(theme) => ({
            ...navbarRow(theme, { isMini }),
            flex: "1 1 auto",
            minWidth: 0,
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            fontSize: { xs: "12px", md: "14px" },
          })}
        >
          <p style={{ margin: 0, display: "flex", alignItems: "center", gap: 4 }}>
            <Home style={{ fontSize: "inherit" }} /> / {menuName}
          </p>
        </SoftBox>

        {/* Actions row */}
        {!isMini && (
          <SoftBox
            sx={(theme) => ({
              ...navbarRow(theme, { isMini }),
              flex: "0 0 auto",
              display: "flex",
              alignItems: "center",
              flexWrap: "nowrap",
              gap: { xs: "4px", md: "8px" },
              justifyContent: "flex-end",
            })}
          >
            {simOnlyUser != 1 && (
              <>
                {/* Knowledge Base — hide label on xs, show on sm+ */}
                <Link to="/video_tutorials" style={{ textDecoration: "none" }}>
                  <SoftTypography
                    variant="button"
                    fontWeight="medium"
                    sx={{
                      color: "white",
                      border: "1px solid #C11D6C",
                      backgroundColor: "#C11D6C",
                      borderRadius: "5px",
                      padding: { xs: "5px 8px", md: "7px 12px" },
                      fontSize: { xs: "10px", sm: "12px", md: "14px" },
                      whiteSpace: "nowrap",
                      display: { xs: "none", sm: "inline-block" },
                    }}
                    className="nav-knowlege-base"
                  >
                    Knowledge Base
                  </SoftTypography>
                  {/* Icon-only on xs */}
                  <IconButton
                    size="small"
                    sx={{
                      backgroundColor: "#C11D6C",
                      display: { xs: "flex", sm: "none" },
                      "&:hover": { backgroundColor: "#a01759" },
                    }}
                    title="Knowledge Base"
                  >
                    <Icon sx={{ color: "#ffff", fontSize: "18px" }}>school</Icon>
                  </IconButton>
                </Link>

                {userType !== 'PAR' && (
                  <Link to="/refer_and_earn" style={{ textDecoration: "none" }}>
                    <SoftTypography
                      variant="button"
                      fontWeight="medium"
                      sx={{
                        color: "white",
                        border: "1px solid #C11D6C",
                        backgroundColor: "#C11D6C",
                        borderRadius: "5px",
                        padding: { xs: "5px 8px", md: "7px 12px" },
                        fontSize: { xs: "10px", sm: "12px", md: "14px" },
                        whiteSpace: "nowrap",
                        display: { xs: "none", sm: "inline-block" },
                      }}
                      className="nav-knowlege-base"
                    >
                      Refer and Earn
                    </SoftTypography>
                    {/* Icon-only on xs */}
                    <IconButton
                      size="small"
                      sx={{
                       
                        backgroundColor: "#C11D6C",
                        display: { xs: "flex", sm: "none" },
                        "&:hover": { backgroundColor: "#a01759",},
                      }}
                      title="Refer and Earn"
                    >
                      <Icon sx={{ color: "#ffff", fontSize: "18px" }}>card_giftcard</Icon>
                    </IconButton>
                  </Link>
                )}
              </>
            )}

            <SoftBox
              color={light ? "white" : "inherit"}
              sx={{ display: "flex", alignItems: "center", gap: { xs: "4px", md: "8px" } }}
            >
             
              <IconButton
                size="small"
                color="inherit"
                sx={{
                  ...navbarMobileMenu,
                  backgroundColor: "#C11D6C",
                  display: { xs: "flex",xl:"none" },
                  "&:hover": { backgroundColor: "#a01759" },
                }}
                onClick={handleMiniSidenav}
              >
                <Icon className="text-white" fontSize="medium">
                  {miniSidenav ? "menu_open" : "menu"}
                </Icon>
              </IconButton>

              {/* Contact Us */}
              <Link to="/contact-us">
                <IconButton
                  sx={{
                    ...navbarContactIconButton,
                    backgroundColor: "#C11D6C",
                    width: { xs: "32px", md: "38px" },
                    height: { xs: "32px", md: "38px" },
                    "&:hover": { backgroundColor: "#a01759" },
                  }}
                  size="small"
                  title="Contact Us"
                >
                  <MdOutlineSms color="white" size="20px" style={{ padding: 2 }} />
                </IconButton>
              </Link>

              {/* Profile / menu */}
              <IconButton
                size="small"
                color="inherit"
                sx={{
                  ...navbarIconButton,
                  backgroundColor: "#C11D6C",
                  width: { xs: "32px", md: "38px" },
                  height: { xs: "32px", md: "38px" },
                  "&:hover": { backgroundColor: "#a01759" },
                }}
                aria-controls="notification-menu"
                aria-haspopup="true"
                variant="contained"
                onClick={handleOpenMenu}
              >
                <MdPerson size="22px" color="white" />
              </IconButton>

              {renderMenu()}
            </SoftBox>
          </SoftBox>
        )}
      </Toolbar>
    </AppBar>
  );
}

DashboardNavbar.defaultProps = {
  absolute: false,
  light: false,
  isMini: false,
};

DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
};

export default DashboardNavbar;